import React from 'react'
import { useLocation } from 'react-router-dom'

import CreateDispatchBinding from '../../../components/CreateDispatchBinding'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const query = new URLSearchParams(useLocation().search)
  const organizationId = parseInt(query.get('organizationId'))

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create a dispatch binding</h1>}></ContextMenu>
      <CreateDispatchBinding organizationId={organizationId} />
    </div>
  )
}
